"use client"

import React, { useState } from 'react';
import { Flag } from "@phosphor-icons/react";
import { reportAdvertisement } from '../app/actions';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ReportButtonProps {
  adId: string;
}

const ReportButton: React.FC<ReportButtonProps> = ({ adId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleReport = async () => {
    try {
      await reportAdvertisement(adId);
      toast.success('Advertisement reported successfully.');
      setIsModalOpen(false);
    } catch (error) {
      console.error('Failed to report advertisement:', error);
      toast.error('Failed to report advertisement.');
    }
  };

  return (
    <>
      <button className="text-error flex items-center" onClick={() => setIsModalOpen(true)}>
        <Flag className="w-4 h-4 mr-1" /> Report advert
      </button>

      {isModalOpen && (
        <div className="modal modal-open">
          <div className="modal-box">
            <h2 className="font-bold text-lg">Report Advertisement</h2>
            <p>Are you sure you want to report this advertisement?</p>
            <div className="modal-action">
              <button className="btn" onClick={() => setIsModalOpen(false)}>Cancel</button>
              <button className="btn btn-error" onClick={handleReport}>Report</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportButton;